import { State } from '../../reducers/rootReducer'

const filterTextEquipmentSelector = (state: State): string => state.equipmentFilter

export default filterTextEquipmentSelector
